import { saveWithSaleTotalConfirmation } from './saleRounding';

export const getOutstandingSaleBalance = (purchase) => {
  const balance = purchase?.balance != null
    ? Number(purchase.balance)
    : Number(purchase?.totalAmount || 0) - Number(purchase?.paidAmount || 0);
  return Number.isFinite(balance) ? Math.max(balance, 0) : 0;
};

// Finalize first, then collect the server balance. Never claim payment succeeded
// in the metadata request: a rejected payment must leave the sale retryable.
export const submitSalePayment = async ({
  purchase, method, details = {}, paymentTerm, documentType, clientId,
  expectedTotalAmount, saveSale, recordPayment, confirm, onTotalChanged,
}) => {
  const isCreditSelection = paymentTerm === 'credit';
  const isOpen = purchase?.saleStatus === 'open';
  const existingCredit = !isOpen && purchase?.paymentTerm === 'credit';
  const payload = {
    paymentTerm: existingCredit || isCreditSelection ? 'credit' : 'immediate',
    paymentMethod: existingCredit || isCreditSelection ? null : method,
    detailForPayment: { ...(purchase?.detailForPayment || {}), ...details },
    ...(isOpen ? { saleStatus: 'completed', checkoutPaymentMethods: [method], expectedTotalAmount } : {}),
    ...(documentType ? { documentType } : {}),
    ...(Number.isInteger(clientId) ? { clientId } : {}),
    ...(isCreditSelection ? {
      creditDueDate: details.creditDueDate || null,
      initialPayment: Math.min(Math.max(Number(details.initialPayment || 0), 0), Number(expectedTotalAmount ?? purchase?.totalAmount ?? 0)),
    } : {}),
  };
  const response = await saveWithSaleTotalConfirmation({
    save: saveSale, payload, confirm, onTotalChanged,
  });
  if (!response) return null;
  const savedPurchase = response.purchase || response;
  const balance = getOutstandingSaleBalance(savedPurchase);
  const paymentMethod = isCreditSelection ? details.initialPaymentMethod || 'efectivo' : method;
  const hasReceivedAmount = details.receivedAmount !== undefined
    && details.receivedAmount !== null && String(details.receivedAmount).trim() !== '';
  const requestedAmount = isCreditSelection
    ? Math.max(Number(details.initialPayment || 0), 0)
    : method === 'efectivo' && hasReceivedAmount ? Number(details.receivedAmount) : balance;
  const amount = Math.min(Math.max(requestedAmount, 0), balance);
  if (amount > 0) {
    await recordPayment({
      amount,
      method: paymentMethod,
      reference: ['transferencia', 'tarjeta'].includes(method)
        ? details.transactionNumber : method === 'cheque' ? details.chequeNumber : undefined,
      note: method === 'cheque' && details.chequeExpiration ? `Expira: ${details.chequeExpiration}` : undefined,
    });
  }
  if (Number(savedPurchase.totalAmount) === 0 && !savedPurchase.isPaid) {
    // A server-confirmed free sale has no payment to collect.
    return saveSale({ isPaid: true });
  }
  return response;
};
